// Pokémon GO type effectiveness multipliers
// Super effective: 1.6x, Not very effective: 0.625x, "Immune" (doubly resisted): 0.390625x
// Source: Pokémon GO uses a modified type chart from the main series

const SE = 1.6;       // Super effective
const NVE = 0.625;    // Not very effective
const IMM = 0.390625; // "Immune" in main series → double resist in GO

// TYPE_CHART[attackType][defenderType] = multiplier
// Only non-1.0 entries are listed; absent means neutral (1.0)
const TYPE_CHART = {
  Normal:   { Rock: NVE, Ghost: IMM, Steel: NVE },
  Fire:     { Fire: NVE, Water: NVE, Grass: SE, Ice: SE, Bug: SE, Rock: NVE, Dragon: NVE, Steel: SE },
  Water:    { Fire: SE, Water: NVE, Grass: NVE, Ground: SE, Rock: SE, Dragon: NVE },
  Electric: { Water: SE, Electric: NVE, Grass: NVE, Ground: IMM, Flying: SE, Dragon: NVE },
  Grass:    { Fire: NVE, Water: SE, Grass: NVE, Poison: NVE, Ground: SE, Flying: NVE, Bug: NVE, Rock: SE, Dragon: NVE, Steel: NVE },
  Ice:      { Fire: NVE, Water: NVE, Grass: SE, Ice: NVE, Ground: SE, Flying: SE, Dragon: SE, Steel: NVE },
  Fighting: { Normal: SE, Ice: SE, Poison: NVE, Flying: NVE, Psychic: NVE, Bug: NVE, Rock: SE, Ghost: IMM, Dark: SE, Steel: SE, Fairy: NVE },
  Poison:   { Grass: SE, Poison: NVE, Ground: NVE, Rock: NVE, Ghost: NVE, Steel: IMM, Fairy: SE },
  Ground:   { Fire: SE, Electric: SE, Grass: NVE, Poison: SE, Flying: IMM, Bug: NVE, Rock: SE, Steel: SE },
  Flying:   { Electric: NVE, Grass: SE, Fighting: SE, Bug: SE, Rock: NVE, Steel: NVE },
  Psychic:  { Fighting: SE, Poison: SE, Psychic: NVE, Dark: IMM, Steel: NVE },
  Bug:      { Fire: NVE, Grass: SE, Fighting: NVE, Poison: NVE, Flying: NVE, Psychic: SE, Ghost: NVE, Dark: SE, Steel: NVE, Fairy: NVE },
  Rock:     { Fire: SE, Ice: SE, Fighting: NVE, Ground: NVE, Flying: SE, Bug: SE, Steel: NVE },
  Ghost:    { Normal: IMM, Ghost: SE, Psychic: SE, Dark: NVE },
  Dragon:   { Dragon: SE, Steel: NVE, Fairy: IMM },
  Dark:     { Fighting: NVE, Psychic: SE, Ghost: SE, Dark: NVE, Fairy: NVE },
  Steel:    { Fire: NVE, Water: NVE, Electric: NVE, Ice: SE, Rock: SE, Steel: NVE, Fairy: SE },
  Fairy:    { Fire: NVE, Poison: NVE, Dragon: SE, Dark: SE, Steel: NVE, Fighting: SE },
};

/**
 * Get the combined type effectiveness multiplier for a move against a defender.
 * @param {string} moveType - The type of the attacking move
 * @param {string[]} defenderTypes - Array of the defender's types (1 or 2)
 * @returns {number} Combined effectiveness multiplier
 */
export function getEffectiveness(moveType, defenderTypes) {
  if (!moveType || !defenderTypes || defenderTypes.length === 0) return 1.0;
  const chart = TYPE_CHART[moveType];
  if (!chart) return 1.0;

  let multiplier = 1.0;
  for (const defType of defenderTypes) {
    multiplier *= (chart[defType] !== undefined ? chart[defType] : 1.0);
  }
  return multiplier;
}

/**
 * Get a human-readable label for an effectiveness multiplier.
 * @param {number} multiplier
 * @returns {{ label: string, className: string }}
 */
export function getEffectivenessLabel(multiplier) {
  if (multiplier > 2) return { label: '2x SE', className: 'eff-double-se' };
  if (multiplier > 1.2) return { label: 'SE', className: 'eff-se' };
  if (multiplier > 0.9) return { label: '', className: '' };
  if (multiplier > 0.5) return { label: 'NVE', className: 'eff-nve' };
  return { label: '2x NVE', className: 'eff-double-nve' };
}

export default TYPE_CHART;
